export const API_URL = process.env.REACT_APP_API_URL;
 
export const APP_URL = process.env.REACT_APP_URL;

/** Post-login landing page (always the Dashboard route). */
export const DASHBOARD_URL = (() => {
  const base = String(APP_URL || "").replace(/\/+$/, "");
  return `${base}/dashboard`;
})();
 
export const AI_API_URL = process.env.REACT_APP_AI_API_URL;
 
export const LOGINAPP_API_URL = process.env.REACT_APP_LOGINAPP_API_URL;
export const LOGIN_URL = process.env.REACT_APP_LOGIN_URL;
 
export const APP_ID =process.env.REACT_APP_APP_ID;
 
export const PYTHON_API_URL = process.env.REACT_APP_PYTHON_API_URL;
 
export const GYPSYBALL_PYTHON_API_URL = process.env.REACT_APP_GYPSYBALL_PYTHON_API_URL;

export const GYPSYBALL_PYTHON_API_TOKEN =process.env.REACT_APP_GYPSYBALL_TOKEN;